import { render, staticRenderFns } from "./check.vue?vue&type=template&id=38a7cfd9&scoped=true&"
import script from "./check.vue?vue&type=script&lang=js&"
export * from "./check.vue?vue&type=script&lang=js&"
import style0 from "./check.vue?vue&type=style&index=0&id=38a7cfd9&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a7cfd9",
  null
  
)

export default component.exports